import { useEffect } from 'react'
import styled from 'styled-components'
import useDashboard from '../../hooks/useDashboard'
import { NowDashboard, PredictionDashboard, OptimizedDashboard } from './plans'
import { PLANS } from '../../utils/planNames'

const Containter = styled.div`
  display: flex;
  justify-self: center;
  align-self: center;
  margin-top: 24px;
  height: 100%;
`

const UserDashboard = () => {
  const { loading, data, dashboardPlan, fetchData } = useDashboard()

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <Containter>
      {loading && !dashboardPlan ? (
        <div>Loading...</div>
      ) : (
        <>
          {dashboardPlan === PLANS.NOW && (
            <NowDashboard graphData={data?.predictionData[0]?.prediction} />
          )}
          {dashboardPlan === PLANS.PREDICTION && (
            <PredictionDashboard
              predictionResult={data?.predictionData}
              userShifts={data?.userShifts}
              sleepTime={data?.sleepTime}
              ingestedCaffeine={data?.ingestedCaffeine}
              bacLevels={data?.bacLevels}
            />
          )}
          {dashboardPlan === PLANS.OPTIMIZED && (
            <OptimizedDashboard
              recommendations={data.recommendations}
              predictionResult={data?.predictionData}
              optimizeResult={data?.optimizeData}
              userShifts={data?.userShifts}
              sleepTime={data?.sleepTime}
              ingestedCaffeine={data?.ingestedCaffeine}
              bacLevels={data?.bacLevels}
            />
          )}
        </>
      )}
    </Containter>

  )
}

export default UserDashboard
